import { Routes } from '@angular/router';
import { AccessMatrixComponent } from './components/access-matrix/access-matrix.component';
import { AuditLogsComponent } from './components/audit-logs/audit-logs.component';
import { NotificationHealthComponent } from './components/notification-health/notification-health.component';
import { NotificationSettingsComponent } from './components/notification-settings/notification-settings.component';
import { ChecklistManagementComponent } from './components/checklist-management/checklist-management.component';
import { AllocationGridComponent } from './components/allocation-grid/allocation-grid.component';
import { EmployeeManagementComponent } from './components/employee-management/employee-management.component';
import { ProjectManagementComponent } from './components/project-management/project-management.component';
import { ProjectsListComponent } from './components/projects-list/projects-list.component';
import { CostCenterManagementComponent } from './components/cost-center-management/cost-center-management.component';
import { RoleManagementComponent } from './components/role-management/role-management.component';
import { DesignationManagementComponent } from './components/designation-management/designation-management.component';
import { CategoryManagementComponent } from './components/category-management/category-management.component';
import { ClientManagementComponent } from './components/client-management/client-management.component';
import { PresalesClientManagementComponent } from './components/presales-client-management/presales-client-management.component';
import { PresalesCostCenterManagementComponent } from './components/presales-cost-center-management/presales-cost-center-management.component';
import { PresalesProjectInventoryComponent } from './components/presales-project-inventory/presales-project-inventory.component';
import { PresaleActivityTrackerComponent } from './components/presale-activity-tracker/presale-activity-tracker.component';
import { PresalesConsolidatedBoardComponent } from './components/presales-consolidated-board/presales-consolidated-board.component';
import { PresalesProjectDetailsComponent } from './components/presales-project-details/presales-project-details.component';
import { PresalesSummaryComponent } from './components/presales-summary/presales-summary.component';
import { ServiceGroupManagementComponent } from './components/service-group-management/service-group-management.component';
import { ForecastComponent } from './components/forecast/forecast.component';
import { FutureAllocationComponent } from './components/future-allocation/future-allocation.component';
import { InvoicingPlanComponent } from './components/invoicing-plan/invoicing-plan.component';
import { InvoicePlanningGridComponent } from './components/invoice-planning-grid/invoice-planning-grid.component';
import { AvailabilityReportComponent } from './components/availability-report/availability-report.component';
import { EffortVarianceReportComponent } from './components/effort-variance-report/effort-variance-report.component';
import { ProjectUtilizationReportComponent } from './components/project-utilization-report/project-utilization-report.component';
import { EmployeeProjectsHistoryComponent } from './components/employee-projects-history/employee-projects-history.component';
import { TimesheetComponent } from './components/timesheet/timesheet.component';
import { MyProjectTasksComponent } from './components/my-project-tasks/my-project-tasks.component';
import { TimesheetReportComponent } from './components/timesheet-report/timesheet-report.component';
import { TimesheetDraftsComponent } from './components/timesheet-drafts/timesheet-drafts.component';
import { TaskManagementComponent } from './components/task-management/task-management.component';
import { LoginComponent } from './components/login/login.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { AuthGuard } from './guards/auth.guard';
import { timesheetUnsavedGuard } from './guards/timesheet-unsaved.guard';
import { CompanyManagementComponent } from './components/company-management/company-management.component';
import { CountyManagementComponent } from './components/county-management/county-management.component';
import { ContractsMaintenanceComponent } from './components/contracts-maintenance/contracts-maintenance.component';
import { ContractsSummaryViewComponent } from './components/contracts-summary-view/contracts-summary-view.component';
import { DefaultRedirectComponent } from './components/default-redirect/default-redirect.component';
import { PortfolioOverviewComponent } from './components/portfolio-overview/portfolio-overview.component';
import { ProjectHealthDeliveryComponent } from './components/project-health-delivery/project-health-delivery.component';
import { InvoicingMilestoneTrackerComponent } from './components/invoicing-milestone-tracker/invoicing-milestone-tracker.component';
import { OnboardingPortalComponent } from './components/onboarding-portal/onboarding-portal.component';
import { OnboardingEmployeeListComponent } from './components/onboarding-employee-list/onboarding-employee-list.component';
import { EmailTemplateManagementComponent } from './components/email-template-management/email-template-management.component';
import { OnboardingTaskTemplatesComponent } from './components/onboarding-task-templates/onboarding-task-templates.component';
import { OffboardingTaskTemplatesComponent } from './components/offboarding-task-templates/offboarding-task-templates.component';
import { OffboardingPortalComponent } from './components/offboarding-portal/offboarding-portal.component';
import { OffboardingCollectionComponent } from './components/offboarding-collection/offboarding-collection.component';
import { ExitQuestionnaireComponent } from './components/exit-questionnaire/exit-questionnaire.component';
import { OutingRsvpComponent } from './components/outing-rsvp/outing-rsvp.component';
import { OutingPhotosComponent } from './components/outing-photos/outing-photos.component';
import { OutingsComponent } from './components/outings/outings.component';
import { OutingSummaryComponent } from './components/outing-summary/outing-summary.component';
import { OutingReportComponent } from './components/outing-report/outing-report.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: '',
    component: DefaultRedirectComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'pc', 'software', 'accounting', 'marketing', 'sales', 'it', 'lnd', 'operations', 'support'] }
  },
  {
    path: 'allocations',
    component: AllocationGridComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
  {
    path: 'forecast',
    component: ForecastComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
  {
    path: 'future-allocation',
    component: FutureAllocationComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
  {
    path: 'outings',
    component: OutingsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm'] }
  },
  {
    path: 'outings/report',
    component: OutingReportComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'marketing'] }
  },
  {
    path: 'outings/summary',
    component: OutingSummaryComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'marketing'] }
  },
  {
    path: 'invoicing-plan',
    component: InvoicingPlanComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
  {
    path: 'invoice-planning-grid',
    component: InvoicePlanningGridComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
   {
     path: 'employees',
     component: EmployeeManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pc'] }
   },
  {
    path: 'projects',
    component: ProjectsListComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm'] }
  },
   {
     path: 'projects-inventory',
     component: ProjectManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm'] }
   },
   {
     path: 'cost-centers',
     component: CostCenterManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin'] }
   },
  {
    path: 'roles',
    component: RoleManagementComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc'] }
  },
  {
    path: 'designations',
    component: DesignationManagementComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc'] }
  },
   {
     path: 'categories',
     component: CategoryManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pc'] }
   },
   {
     path: 'service-groups',
     component: ServiceGroupManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin'] }
   },
   {
     path: 'clients',
     component: ClientManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin'] }
   },
   // Presales Project Management — Admin + PM
   {
     path: 'presales/summary',
     component: PresalesSummaryComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'sales'] }
   },
   {
     path: 'presales/inventory',
     component: PresalesProjectInventoryComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'sales'] }
   },
   {
     // Presales projects and their trackable activities on one board. Same audience as the
     // inventory it sits beside.
     path: 'presales/activity-tracker',
     component: PresaleActivityTrackerComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'sales'] }
   },
   {
     // Trial screen: presales deals and tracker activities on one set of Progress columns.
     // Sits alongside the Inventory and the Activity Tracker rather than replacing either,
     // so the three can be compared before anything is retired. Same audience as both.
     path: 'presales/consolidated-board',
     component: PresalesConsolidatedBoardComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'sales'] }
   },
   {
     path: 'presales/details',
     component: PresalesProjectDetailsComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'sales'] }
   },
   {
     path: 'presales/clients',
     component: PresalesClientManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'sales'] }
   },
   {
     path: 'presales/cost-centers',
     component: PresalesCostCenterManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'sales'] }
   },
   {
     path: 'availability-report',
     component: AvailabilityReportComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'finance', 'sales'] }
   },
   {
     path: 'timesheet',
     component: TimesheetComponent,
     canActivate: [AuthGuard],
     canDeactivate: [timesheetUnsavedGuard],
     data: { roles: ['admin', 'pm', 'finance', 'software', 'accounting', 'marketing', 'sales', 'operations', 'support'] }
   },
   {
     // The Projects module's Tasks tab, reached from Work Log and scoped server-side to the
     // caller's own allocated projects. 'software' is listed explicitly because auth.guard
     // maps it non-admin-inclusively — an Admin without the Software group would otherwise
     // fail a software-only route.
     path: 'my-project-tasks',
     component: MyProjectTasksComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'software'] }
   },
   {
     path: 'timesheet-report',
     component: TimesheetReportComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'finance', 'sales'] }
   },
   {
     // Allocation vs actual effort. PM for delivery, Finance for costing — Sales is omitted
     // because effort variance is delivery/cost data rather than pipeline data.
     path: 'effort-variance-report',
     component: EffortVarianceReportComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'finance'] }
   },
   {
     // The same plan-vs-actual measurements as the effort variance report, grouped by
     // project instead of by person, so it carries the same roles.
     path: 'project-utilization-report',
     component: ProjectUtilizationReportComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'finance'] }
   },
   {
     path: 'timesheet-drafts',
     component: TimesheetDraftsComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'finance', 'sales', 'operations', 'support'] }
   },
   {
     path: 'employee-projects-history',
     component: EmployeeProjectsHistoryComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin', 'pm', 'finance', 'sales'] }
   },
   {
     path: 'tasks',
     component: TaskManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin'] }
   },
   {
     path: 'checklist-management',
     component: ChecklistManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin'] }
   },
   {
     path: 'companies',
     component: CompanyManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin'] }
   },
   {
     path: 'counties',
     component: CountyManagementComponent,
     canActivate: [AuthGuard],
     data: { roles: ['admin'] }
   },
  {
    path: 'dashboard/portfolio-overview',
    component: PortfolioOverviewComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
  {
    path: 'dashboard/project-health-delivery',
    component: ProjectHealthDeliveryComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
  {
    path: 'dashboard/invoicing-milestone-tracker',
    component: InvoicingMilestoneTrackerComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pm', 'finance', 'sales'] }
  },
  {
    path: 'contracts-maintenance',
    component: ContractsMaintenanceComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'finance'] }
  },
  {
    path: 'contracts-summary-view',
    component: ContractsSummaryViewComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'finance'] }
  },
  // Onboarding — dashboard and employee list accessible to IT and L&D (filtered by role in UI)
  {
    path: 'onboarding',
    component: OnboardingPortalComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc', 'it', 'lnd'] }
  },
  {
    path: 'onboarding/employees',
    component: OnboardingEmployeeListComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc', 'it', 'lnd'] }
  },
  {
    path: 'onboarding/email-templates',
    component: EmailTemplateManagementComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc'] }
  },
  {
    path: 'onboarding/task-templates',
    component: OnboardingTaskTemplatesComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc'] }
  },
  // Offboarding — main views accessible to IT and L&D; template management is admin/pc only
  {
    path: 'offboarding',
    component: OffboardingPortalComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc', 'it', 'lnd'] }
  },
  {
    path: 'offboarding/collection',
    component: OffboardingCollectionComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc', 'it', 'lnd'] }
  },
  {
    path: 'offboarding/task-templates',
    component: OffboardingTaskTemplatesComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'pc'] }
  },
  // Audit Logs (admin only)
  {
    path: 'audit-logs',
    component: AuditLogsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  // Access Matrix — which role reaches which page (admin only)
  {
    path: 'access-matrix',
    component: AccessMatrixComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  // Notification Health (admin only)
  {
    path: 'notification-health',
    component: NotificationHealthComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  // Notification Settings (admin only)
  {
    path: 'notification-settings',
    component: NotificationSettingsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  // Public exit questionnaire (no auth required — token-based access)
  {
    path: 'questionnaire/:token',
    component: ExitQuestionnaireComponent
  },
  // Public outing RSVP (no auth required — token-based access)
  {
    path: 'outing-rsvp/:token',
    component: OutingRsvpComponent
  },
  // Public outing photos gallery (no auth — token-based; from the Marketing "Done" email)
  {
    path: 'outing-photos/:token',
    component: OutingPhotosComponent
  },
  // Wildcard route for 404 - must be last
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full'
  }
];
